/**
 * Testimonial read-more toggles and the load-more pager.
 *
 * Read-more wiring runs on load and again as hidden cards are revealed: a clamped element measures zero height while its
 * card carries the `hidden` attribute, so it can only be measured once the card is actually shown.
 */
const wireReadMore = (review: HTMLElement): void => {
	const toggle = review.parentElement?.querySelector<HTMLButtonElement>('[data-review-toggle]');
	if (!toggle || review.dataset.reviewWired || review.scrollHeight <= review.clientHeight + 1) {
		return;
	}

	review.dataset.reviewWired = 'true';
	toggle.hidden = false;
	toggle.addEventListener('click', () => {
		const expanded = review.classList.toggle('line-clamp-none');
		review.classList.toggle('line-clamp-4', !expanded);
		toggle.textContent = expanded ? 'Show less' : 'Read more';
	});
};

document.querySelectorAll<HTMLElement>('[data-review]').forEach(wireReadMore);

const moreButton = document.querySelector<HTMLButtonElement>('[data-reviews-more]');
const list = document.querySelector<HTMLElement>('[data-reviews-list]');

if (moreButton && list) {
	const batch = Number(moreButton.dataset.reviewsBatch) || 6;

	moreButton.addEventListener('click', () => {
		Array.from(list.querySelectorAll<HTMLElement>('[data-review-card][hidden]'))
			.slice(0, batch)
			.forEach((card) => {
				card.hidden = false;
				card.querySelectorAll<HTMLElement>('[data-review]').forEach(wireReadMore);
			});

		if (list.querySelector('[data-review-card][hidden]') === null) {
			moreButton.hidden = true;
		}
	});
}
